import Window from './Window';

function AboutWindow() {
  return (
    <section className="">
      <Window
        title="about.txt"
        barBgColor="#9d8ff1"
        borderColor="#8576de"
        bgColor="#ebdafa"
      >
        <div className="d-flex flex-column flex-sm-row">
          <div className="text-center p-3 pb-0 flex-grow-1 d-flex flex-column justfiy-content-center">
            <h2>Kay</h2>
            <h4>she/her | 20s | Digital Artist</h4>
          </div>
        </div>
        <hr className="mx-4" style={{ color: '#8576de' }} />
        <p className="px-4 text-center">
          Hi there! I'm Kay and I've been an artist and a Vocaloid fan since
          2011. While I am an avid Miku fan, my absolute favorite Vocaloid is
          Kagamine Rin. She's my muse and keeps me wanting to draw every day
          &lt;3 I also collect Miku figures!
        </p>
      </Window>
    </section>
  );
}

export default AboutWindow;
